var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66935 8.9339L17.388 2L32.5242 8.9339L34 26.4599L17.388 36L1 26.4599L2.66935 8.9339Z",
    fill: "url(#paint0_linear_3612_13351)",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66935 8.9339L17.388 2L32.5242 8.9339L34 26.4599L17.388 36L1 26.4599L2.66935 8.9339Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66935 8.9339L17.388 7.07155L32.5242 8.9339L28.2419 23.3994L17.388 36L6.68548 23.3994L2.66935 8.9339Z",
    fill: "url(#paint1_linear_3612_13351)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66935 8.9339L17.388 7.07155L32.5242 8.9339L28.2419 23.3994L17.388 36L6.68548 23.3994L2.66935 8.9339Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2419 23.3994H17.388H6.68548L12.25 14.6484L17.388 7.07155L22.8468 14.6484L28.2419 23.3994Z",
    fill: "url(#paint2_linear_3612_13351)",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2419 23.3994H17.388H6.68548L12.25 14.6484L17.388 7.07155L22.8468 14.6484L28.2419 23.3994Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.6484H22.8468L17.388 23.3994L12.25 14.6484Z",
    fill: "url(#paint3_linear_3612_13351)",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 14.6484H22.8468L17.388 23.3994L12.25 14.6484Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66935 8.9339L1 26.4599M2.66935 8.9339L17.388 2M2.66935 8.9339L6.68548 23.3994M2.66935 8.9339L17.388 7.07155M2.66935 8.9339L12.25 14.6484M32.5242 8.9339L34 26.4599M32.5242 8.9339L17.388 2M32.5242 8.9339L28.2419 23.3994M32.5242 8.9339L17.388 7.07155M32.5242 8.9339L22.8468 14.6484M34 26.4599L17.388 36M34 26.4599L28.2419 23.3994M1 26.4599L17.388 36M1 26.4599L6.68548 23.3994M17.388 2V7.07155M17.388 36L28.2419 23.3994M17.388 36L6.68548 23.3994M17.388 36V23.3994M28.2419 23.3994H17.388M28.2419 23.3994L22.8468 14.6484M6.68548 23.3994H17.388M6.68548 23.3994L12.25 14.6484M17.388 7.07155L22.8468 14.6484M17.388 7.07155L12.25 14.6484M17.388 23.3994L22.8468 14.6484M17.388 23.3994L12.25 14.6484M12.25 14.6484H22.8468",
    stroke: "url(#paint4_radial_3612_13351)",
    strokeWidth: 1.2268
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3612_13351",
    x1: 17.5,
    y1: 2,
    x2: 17.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1768E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3612_13351",
    x1: 17.5,
    y1: 2,
    x2: 17.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1768E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3612_13351",
    x1: 17.5,
    y1: 2,
    x2: 17.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1768E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3612_13351",
    x1: 17.5,
    y1: 2,
    x2: 17.5,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1768E5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3612_13351",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.5 23.782) rotate(-90) scale(39.7384 23.579)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1e6c6a813bbc6936a77b758ceac2c216.svg";
export { ForwardRef as ReactComponent };